<template>
  <div>

    <v-tabs
    class="border-b--thin"
    fixed-tabs
    color="deep-purple accent-4"
    v-model="tab"
    >
      <v-tab>
        Inventory
      </v-tab>
      <v-tab>
        History
      </v-tab>
    </v-tabs>
    <div class="">

      <inventory
      v-if="tab === 0"
      :id="id">
      </inventory>

      <history
      v-if="tab === 1"
      :id="id">
      </history>

    </div>

  </div>
</template>

<script>
import Inventory from '@/components/nav/tracer/views/name-search-lvl2/inventory/Main'
import History from '@/components/nav/tracer/views/name-search-lvl2/history/Main'

export default {
  components: {
    Inventory,
    History
  },
  props: ['id'],
  data () {
    return {
      tab: 0
    }
  },
  created () {
  }
}
</script>